import cleanedFilename from '~/util/cleanedFilename';

export default {
  DROPDOWN: `${cleanedFilename(__filename)}-dropdown`,
  EMAIL_ERROR_LABEL: `${cleanedFilename(__filename)}-email-error-label`,
  EMAIL_SOURCE_LINK: `${cleanedFilename(__filename)}-email-source-link`,
};
